import {IStripeRequirement} from "../interfaces/IStripeRequirement";

export const StripeRequirements: IStripeRequirement[] = [
  {
    requirement: 'Business type',
    code: 'business_type'
  },
  {
    requirement: 'Business structure',
    code: 'company.structure'
  },
  {
    requirement: 'Merchant category code',
    code: 'business_profile.mcc'
  },
  {
    requirement: 'Business URL',
    code: 'business_profile.url'
  },
  {
    requirement: 'Product description',
    code: 'business_profile.product_description'
  },
  {
    requirement: 'Support phone number',
    code: 'business_profile.support_phone'
  },
  {
    requirement: 'Terms of service IP Address',
    code: 'tos_acceptance.ip'
  },
  {
    requirement: 'Terms of service date',
    code: 'tos_acceptance.date'
  },
  {
    requirement: 'External account',
    code: 'external_account'
  },
  {
    requirement: 'Company\'s Name',
    code: 'company.name'
  },
  {
    requirement: 'Company\'s Address',
    code: 'company.address.line1'
  },
  {
    requirement: 'Company\'s Postal/Zip code',
    code: 'company.address.postal_code'
  },
  {
    requirement: 'Company\'s City',
    code: 'company.address.city'
  },
  {
    requirement: 'Company\'s Province/State',
    code: 'company.address.state'
  },
  {
    requirement: 'Company phone',
    code: 'company.phone'
  },
  {
    requirement: 'Company tax ID',
    code: 'company.tax_id'
  },
  {
    requirement: 'Directors provided',
    code: 'company.directors_provided'
  },
  {
    requirement: 'Representative\'s First Name',
    code: 'representative.first_name'
  },
  {
    requirement: 'Representative\'s Last Name',
    code: 'representative.last_name'
  },
  {
    requirement: 'Representative\'s Date of birth (day)',
    code: 'representative.dob.day'
  },
  {
    requirement: 'Representative\'s Date of birth (month)',
    code: 'representative.dob.month'
  },
  {
    requirement: 'Representative\'s Date of birth (year)',
    code: 'representative.dob.year'
  },
  {
    requirement: 'Representative\'s Address',
    code: 'representative.address.line1'
  },
  {
    requirement: 'Representative\'s Postal/Zip code',
    code: 'representative.address.postal_code'
  },
  {
    requirement: 'Representative\'s City',
    code: 'representative.address.city'
  },
  {
    requirement: 'Representative\'s Province/State',
    code: 'representative.address.state'
  },
  {
    requirement: 'Representative\'s Email',
    code: 'representative.email'
  },
  {
    requirement: 'Representative\'s phone number',
    code: 'representative.phone'
  },
  {
    requirement: 'Representative\'s Job title',
    code: 'representative.relationship.title'
  },
  {
    requirement: 'Director\'s First Name',
    code: 'directors.first_name'
  },
  {
    requirement: 'Director\'s Last Name',
    code: 'directors.last_name'
  },
  {
    requirement: 'Director\'s Email',
    code: 'directors.email'
  }
]
